import React, { Component } from "react";

import Jumbotron from "../utils/Jumbotron";

import Layout from "../header_footer/Layout";

import axios from 'axios';

import PropTypes from "prop-types";

import AvisosSmall from './AvisosSmall';

class Avisos extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
};

  constructor(props) {
    super(props);

    this.state = {
      edital: [],
    };
  }

  componentDidMount = () => {
    this.loadEditais();
  };

  loadEditais = async () => {
    let res = {};
    try {
      res = await axios.get("/api/avisos", {
        params: {
          frontPage: false,
        },
        headers: {
          APIKEY: "q7tXDJZX1StZAKZsKTLu5FRBs5k42vSf",
          "Content-Type": "application/json",
        },
      });
    } catch (error) {
      console.log(error);
    }

    let edital = [];

    if(res.data !== undefined && res.data.arrayAvisos !== undefined) {
      edital = res.data.arrayAvisos;
    }
    

    this.setState({ edital });
  };

  comunidadeClicked = () => {
    this.context.router.history.push(
      "/executivo"
    );
  }

  render() {
    const items = this.state.edital.map(function (item) {
      return <AvisosSmall item={item} key={item.title}></AvisosSmall>;
    });

    return (
      <Layout>
        <Jumbotron title={"Comunidade"}></Jumbotron>

        <div className="container">
          <div className="comunidade-flex">

            <div className="comunidade-sections">
              <div className="comunidade-section section-selected">
                <p>Comunidade</p>
              </div>
              <div onClick={this.comunidadeClicked} className="comunidade-section">
                <p>Executivo</p>
              </div>
            </div>
            <div className="comunidade-content">
            {items}
            </div>
          </div>
        </div>
      </Layout>
    );
  }
}

export default Avisos;
